<app-nav titulo="Medios de Pago" descripcion="Configuración de los medios de pago disponibles en la calculadora de cotización.">
    <div class="medios-pago">
        <app-table-filter [filters]="filters" (values)="setFilterValues($event)"></app-table-filter>
        <app-data-table
            [rows]="mediosPago"
            [columns]="columns"
            [paginatorStatus]="paginatorStatus"
            [externalPagination]="true"
            (updateRows)="updatePage($event)"
            (sortFn)="updateSort($event)"
        ></app-data-table>
        <button mat-raised-button class="garantor-button add-button" color="primary" routerLink="./nuevo">
            <mat-icon matPrefix>add</mat-icon>
            <span>Nuevo medio de pago</span>
        </button>
    </div>
</app-nav>

<ng-template #ivaColumnTemplate let-row="row">
    <span *ngIf="row.aplicaIva">{{ row.iva }}%</span>
    <span *ngIf="!row.aplicaIva" style="color: rgba(0,0,0,0.38);">No</span>
</ng-template>

<ng-template #costoIntColumnTemplate let-row="row">
    <span *ngIf="row.costoInt != null">{{ row.costoInt }}%</span>
    <span *ngIf="row.costoInt == null" style="color: rgba(0,0,0,0.38);">—</span>
</ng-template>

<ng-template #activoColumnTemplate let-row="row">
    <span [class]="row.activo ? 'status-badge active' : 'status-badge inactive'">
        {{ row.activo ? 'Activo' : 'Inactivo' }}
    </span>
</ng-template>

<ng-template #actionsColumnTemplate let-row="row">
    <div class="table-row-buttons">
        <button mat-icon-button matTooltip="Editar" [routerLink]="'./' + row.id + '/editar'">
            <mat-icon color="primary">edit</mat-icon>
        </button>
        <button mat-icon-button matTooltip="Dar de baja" (click)="deleteMedioPago(row)">
            <mat-icon color="accent">delete</mat-icon>
        </button>
    </div>
</ng-template>
